<template>
  <div class="login-bg">
    <h2 class="login-title">
      <img src="../../assets/img/logo.png" style="width: 125px" alt="">
    </h2>
    <div class="search-box">
      <p>庭审码</p>
      <el-input v-model="attendCode" placeholder="请输入庭审码"></el-input>
      <div class="btn-box">
        <el-button type="primary" size="medium" style="margin-top: 20px;width:100%;" @click="handleSearch">确 定
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      attendCode: null
    }
  },
  methods: {
    handleSearch() {
      const loading = this.$loading({
        lock: true,
        text: '跳转中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      })
      this.$Http.getJoinMeetingUrl({
        attendCode: this.attendCode
      }).then(res => {
        loading.close()
        if (res.success) {
          location.href = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  .login-bg {
    padding-top: 100px;
    height: 100%;
    width: 100%;
    background: url('../../assets/img/login-bgm.jpg');
    background-size: cover;
    overflow: hidden;

    .login-title {
      text-align: center;
      color: #FFFFFF;
    }

    .search-box {
      margin: 100px 20px 0 20px;
      border-radius: 10px;
      padding: 20px;

      p {
        color: #FFF;
        font-size: 16px;
        line-height: 40px;
      }

      .btn-box {
        text-align: center;
      }
    }
  }
</style>
